import {createSlice} from '@reduxjs/toolkit';
import {loginStates, passwordResetStates} from './constants';

const initialState = {
    loginState: loginStates.ENTER_USERNAME,
    passwordResetState: passwordResetStates.ENTER_EMAIL,
    invalidResetCode: false,
    failedLoginAttempts: 0,
};

export default createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        setLoginState: (state, action) => {
            state.loginState = action.payload;
            return state;
        },
        setPasswordResetState: (state, action) => {
            state.passwordResetState = action.payload;
            return state;
        },
        setInvalidResetCode: (state, action) => {
            state.invalidResetCode = action.payload;
            return state;
        },
        incrementFailedLoginAttempts: (state) => {
            state.failedLoginAttempts++;
            return state;
        },
        resetFailedLoginAttempts: (state) => {
            state.failedLoginAttempts = 0;
            return state;
        }
    },
});